var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white min-h-screen"},[_c('PropertyHubNavigation',{ref:"navigation",staticClass:"relative top-0 w-full z-20",attrs:{"display-mode":"bar"}}),_c('iframe',{staticClass:"mt-12",attrs:{"src":"https://zilaracapcana.resortsbyhyatt.com/?seating"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }